var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input flex items-center relative"},[_vm._t("default"),_c('icon',{staticClass:"w-5 h-5 flex-shrink-0 pointer-events-none absolute right-0 mr-1",attrs:{"name":"arrow-down"}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }